// extracted by mini-css-extract-plugin
export default {"qrCode":"QrCodes_qrCode__HUbR-","borderQr":"QrCodes_borderQr__QoNXG"};